/**
 * Vendor-neutral event taxonomy. `action` is the human-readable label shown in
 * the CSM tool's activity stream; `weight` signals importance for health scoring.
 * Call sites reference TrackingEvent members only — never raw strings.
 */
export enum TrackingEvent {
    LoggedIn = 'loggedIn',
    Navigated = 'navigated',
    ImportedSalaryFile = 'importedSalaryFile',
    CreatedPayEquityAudit = 'createdPayEquityAudit',
    WorkedInPayEquityAudit = 'workedInPayEquityAudit',
    TaggedEqualWork = 'taggedEqualWork',
    TaggedEmployment = 'taggedEmployment',
    CreatedEmployee = 'createdEmployee',
    TriggeredIntegrationSync = 'triggeredIntegrationSync',
    AccessedSupportFile = 'accessedSupportFile',
    ViewedPublishedProfile = 'viewedPublishedProfile',
    ViewedUnpublishedProfile = 'viewedUnpublishedProfile',
    ChangedSecuritySettings = 'changedSecuritySettings',
}

export type TrackingEventDefinition = {
    action: string;
    weight: number;
};

export const TRACKING_EVENTS: Record<TrackingEvent, TrackingEventDefinition> = {
    [TrackingEvent.LoggedIn]:                 { action: 'Logged in', weight: 1 },
    [TrackingEvent.Navigated]:                { action: 'Navigated', weight: 1 },
    [TrackingEvent.ImportedSalaryFile]:       { action: 'Imported salary file', weight: 3 },
    [TrackingEvent.CreatedPayEquityAudit]:    { action: 'Created pay equity audit', weight: 5 },
    [TrackingEvent.WorkedInPayEquityAudit]:   { action: 'Worked in pay equity audit', weight: 3 },
    [TrackingEvent.TaggedEqualWork]:          { action: 'Tagged equal work', weight: 2 },
    [TrackingEvent.TaggedEmployment]:         { action: 'Tagged employment', weight: 2 },
    [TrackingEvent.CreatedEmployee]:          { action: 'Created employee', weight: 2 },
    [TrackingEvent.TriggeredIntegrationSync]: { action: 'Triggered integration sync', weight: 2 },
    [TrackingEvent.AccessedSupportFile]:      { action: 'Accessed support file', weight: 1 },
    [TrackingEvent.ViewedPublishedProfile]:   { action: 'Viewed published profile', weight: 1 },
    [TrackingEvent.ViewedUnpublishedProfile]: { action: 'Viewed unpublished profile', weight: 1 },
    [TrackingEvent.ChangedSecuritySettings]:  { action: 'Changed security settings', weight: 3 },
};
